var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("User Import")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "spacer-b-2 w-25" },
          [
            _c("label", { attrs: { for: "role" } }, [
              _vm._v("Select import type"),
            ]),
            _vm._v(" "),
            _c("selectize", {
              staticClass: "selectize selectize-single",
              attrs: {
                id: "role",
                name: "role",
                placeholder: "Role",
                options: _vm.roleOptions,
              },
              model: {
                value: _vm.role,
                callback: function ($$v) {
                  _vm.role = $$v
                },
                expression: "role",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.role !== "profile_images"
          ? _c("p", [
              _vm._v("Download a CSV and bulk import. "),
              _c(
                "a",
                {
                  attrs: { href: "#", target: "_blank" },
                  on: {
                    click: function ($event) {
                      return _vm.downloadExample(_vm.operations.create, $event)
                    },
                  },
                },
                [_vm._v("Download an example file")]
              ),
              _vm._v(". "),
              _c("br"),
              _vm._v(
                " Optionally add profile images, compressed in a zip file."
              ),
            ])
          : _c("p", [
              _vm._v("Download a CSV and bulk profile image import. "),
              _c(
                "a",
                {
                  attrs: { href: "#", target: "_blank" },
                  on: {
                    click: function ($event) {
                      return _vm.downloadExample(
                        _vm.operations.update_profile_images,
                        $event
                      )
                    },
                  },
                },
                [_vm._v("Download an example file")]
              ),
              _vm._v(". "),
              _c("br"),
              _vm._v(" Add profile images, compressed in a zip file."),
            ]),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("form", [
          _c(
            "div",
            {
              staticClass: "panel panel-grey",
              class: { "is-droppable": _vm.dropable },
            },
            [
              _c("div", { staticClass: "panel-body" }, [
                _c("div", { staticClass: "form-horizontal" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm.isSuccess
                      ? _c("div", { staticClass: "col-md-12 text-center" }, [
                          _c(
                            "h3",
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("sentenceCase")(_vm.selectedRoleLabel)
                                ) +
                                  " file uploaded. Users will be reviewed and added/updated to your\n                    "
                              ),
                              _c(
                                "router-link",
                                { attrs: { to: "/" + _vm.selectedRoleLink } },
                                [_vm._v("list")]
                              ),
                              _vm._v(".\n                  "),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c(
                        "div",
                        {
                          staticClass: "dropbox",
                          on: {
                            drop: _vm.fileDropped,
                            dragenter: function ($event) {
                              _vm.dropable = true
                            },
                            dragleave: function ($event) {
                              _vm.dropable = false
                            },
                          },
                        },
                        [
                          _vm.isInitial
                            ? _c("input", {
                                staticClass: "form-control input-file",
                                attrs: {
                                  name: "uploadFile",
                                  disabled: _vm.isSaving,
                                  type: "file",
                                  accept:
                                    "text/csv,zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.setFiles($event.target.files)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("help-block", { attrs: { field: "file" } }),
                          _vm._v(" "),
                          _vm.isInitial
                            ? _c("p", [
                                _vm._v(
                                  "\n                      Drag your file(s) here to begin "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                      or click to browse\n                    "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSuccess
                            ? _c("p", [
                                _vm._v(
                                  "\n                      User File Uploaded "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                      Drag your file(s) here\n                    "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSaving
                            ? _c("p", [
                                _vm._v(
                                  "\n                      Uploading files...\n                    "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isFailedWithErrorsAndWarnings
                            ? _c("p", [
                                _vm._v(
                                  "\n                      Failed to import\n                    "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          this.uploadFile && _vm.isInitial
                            ? _c("span", [
                                _vm._v(
                                  "Upload File: " + _vm._s(this.uploadFile.name)
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          this.profileImages && _vm.isInitial
                            ? _c("span", [
                                _vm._v(
                                  "Profile images (zip) File: " +
                                    _vm._s(this.profileImages.name)
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _vm.isFailed
                      ? _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [
                            _c("validate-input", {
                              attrs: {
                                "file-error": _vm.fileError,
                                "importer-errors": _vm.importerErrors,
                                "importer-warnings": _vm.importerWarnings,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _vm.isInitial
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button", id: "formSubmit", name: "formSubmit" },
                on: {
                  click: function ($event) {
                    return _vm.uploadFiles(false)
                  },
                },
              },
              [_vm._v("Start upload")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isSuccess
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button", id: "formSubmit", name: "formSubmit" },
                on: { click: _vm.reset },
              },
              [_vm._v("Upload another file")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isFailed
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.reset },
              },
              [_vm._v("Retry")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isFailedWithWarningsOnly
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  type: "button",
                  id: "overrideAndUpload",
                  name: "overrideAndUpload",
                },
                on: {
                  click: function ($event) {
                    return _vm.uploadFiles(true)
                  },
                },
              },
              [_vm._v("Ignore warnings and upload")]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Expected date format : YYYY-MM-DD (e.g. 1990-12-31)"),
      _c("br"),
      _vm._v(
        "\n      Expected value separator : , (e.g. Alabama, Alaska, Arizona)"
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }